import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Meta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/program',
    name: 'Program',
    component: () =>
      import('../views/Program.vue'),
  },
  {
    path: '/committee',
    name: 'Committee',
    component: () =>
      import('../views/Committee.vue'),
  },
  {
    path: '/forum/:name?',
    name: 'Forum',
    props: true,
    component: () =>
      import('../views/Forum.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () =>
      import('../views/Contact.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/cssnlp/',
  routes,
});

export default router;
